import { useTranslation } from 'react-i18next';
import { Group } from '../../../api/groups';
import useGroups from '../hooks/useGroups';
import { useContext } from 'react';
import ModalContext from '../../../contexts/ModalContext';
import GroupDetailsModal from '../modals/group-details/GroupDetailsModal';
import StudentStatusPills from './StudentStatusPills';

import List from '@pelckmans/elementis/components/list';
import Pill from '@pelckmans/elementis/components/pill';
import SmartschoolIcon from '@pelckmans/elementis/icons/smartschool';
import BrandIcon from '../../../shared-components/BrandIcon';

export default function GroupListItem({ group }: { group: Group }): JSX.Element {
  const { t } = useTranslation();
  const { selectedSchoolYear, onGroupsChange } = useGroups();
  const { showModal } = useContext(ModalContext);

  const addGroupToState = (group: Group) => {
    onGroupsChange(prevGroups => {
      return (prevGroups || []).map(g => {
        if (g.id === group.id) {
          return group;
        }

        return g;
      });
    });
  };

  const removeGroupFromState = (group: Group) => {
    onGroupsChange(prevGroups => {
      return (prevGroups || []).filter(g => g.id !== group.id);
    });
  };
  return (
    <List.Item
      title={group.name}
      icon={group.smartschoolGroupId ? <SmartschoolIcon /> : <BrandIcon />}
      onClick={() => {
        if (!selectedSchoolYear) return;

        showModal(
          <GroupDetailsModal
            id="group-details-modal"
            groupId={group.id}
            schoolYear={selectedSchoolYear}
            editable={!selectedSchoolYear?.hasPassed}
            onGroupUpdate={addGroupToState}
            onGroupDelete={removeGroupFromState}
          />,
        );
      }}
      as="button"
      contentArea={<StudentStatusPills group={group} />}
      pillGroupProps={{
        role: 'group',
        'aria-label': t('PAGES.MY_GROUPS.LIST_GROUP.SUBJECTS.A11Y_LABEL'),
        children: group.subjects.map((s, i) => <Pill key={`${i}-${s}`}>{s}</Pill>),
      }}
    />
  );
}
